
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 3000 3000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-mercury",attrs:{"stroke":"#F6FBE5","stroke-width":"37","d":"M1643.61 1292.31a252.5 252.5 0 0 1 76.75 84.42 252.4 252.4 0 0 1 31.77 109.59c2.09 38.47-4.66 76.91-19.72 112.38a252.5 252.5 0 0 1-67.17 92.22 252.46 252.46 0 0 1-100.91 53.25 252.7 252.7 0 0 1-114.05 3.39 252.6 252.6 0 0 1-103.89-47.16 252.5 252.5 0 0 1-72.53-88.08"}}),_c('circle',{staticClass:"i-sun",attrs:{"cx":"1500","cy":"1500","r":"128","fill":"#F7FAFA"}}),_c('path',{staticClass:"i-venus",attrs:{"stroke":"#09A098","stroke-dasharray":"3 10","d":"M1037.02 1280.21a512.4 512.4 0 0 1 139.03-177.34 512.55 512.55 0 0 1 201.66-100.57 512.525 512.525 0 0 1 576.45 260.21 512.66 512.66 0 0 1 57.96 217.76 512.505 512.505 0 0 1-173.15 404.12"}}),_c('path',{staticClass:"i-earth",attrs:{"stroke":"#F9A241","stroke-dasharray":"12 24","stroke-width":"2","d":"M1184.65 2661.26c-275.033-74.69-514.629-244.57-676.124-479.38-161.495-234.82-234.404-519.34-205.744-802.89"}})])
          )
        }
      }
    